import { Component, OnInit } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manual-question-dialog',
  templateUrl: './manual-question-dialog.component.html',
  styleUrls: ['./manual-question-dialog.component.css'],
  standalone: false,
})
export class ManualQuestionDialogComponent implements OnInit {

  readonly manualTopLink: string = AppConst.ROUTING_LINK_MANUAL_INDEX;
  readonly qnameDialogLink: string = AppConst.ROUTING_LINK_MANUAL_QNAME_DIALOG;
  readonly qcompDialogLink: string = AppConst.ROUTING_LINK_MANUAL_QCOMP_DIALOG;
  readonly qitemDialogLink: string = AppConst.ROUTING_LINK_MANUAL_QITEM_DIALOG;

  currentLang: string = 'ja';

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translate.currentLang;
  }

}
